<template>
          <v-card elevation='2'>
            <v-card-text>
              <h2 class="display-1 mb-4">{{ title }}</h2>
              <template>
                <v-flex>
                  <v-menu
                    ref="cfrStartDate"
                    v-model="cfrStartDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        label="Start Date"
                        format="dddd, MM DD YYYY"
                        @change="value => cfrStartDate = value"
                        :value="dateFormatted(cfrStartDate)"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="cfrStartDate"
                      @input="cfrStartDateMenu = false"
                      no-title
                      scrollable
                      :show-current="cfrEndDate"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </template>
              <template>
                <v-flex>
                  <v-menu
                    ref="cfrEndDate"
                    v-model="cfrEndDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        label="End Date"
                        format="dddd, MM DD YYYY"
                        @change="value => cfrEndDate = value"
                        :value="dateFormatted(cfrEndDate)"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="cfrEndDate"
                      @input="cfrEndDateMenu = false"
                      no-title
                      scrollable
                      :show-current="cfrStartDate"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getShiftCount" color="primary">
                  Get {{ title }}
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>

</template>

<script>

export default {
  components: {
  },
  computed: {
  },
  created () {
  },
  props: [
    'title'
  ],
  watch: {
  },
  data: function () {
    return {
      cfrStartDateMenu: false,
      cfrEndDateMenu: false,
      cfrStartDate: this.$moment().subtract(8, "weeks").format('YYYY-MM-DD'),
      cfrEndDate: this.$moment().subtract(1, "weeks").format('YYYY-MM-DD'),
    }
  },
  computed: {
  },
  methods: {
    getShiftCount: function () {
      this.$router.push({
        name: 'employeeShiftCountReport',
        query: {
          startDate: this.cfrStartDate,
          endDate: this.cfrEndDate,
        }
      })
    },

    dateFormatted: function (date) {
      return date ? this.$moment(date).format('dddd, MMMM D') : ''
    },
  },
}
</script>
